import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// PROPTYPES
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  WhiteSpace,
  ActivityIndicator,
  Popover,
  Carousel,
  WingBlank,
} from 'antd-mobile';
import { loginModalOpen } from 'actions/Login/login.action';
import store from 'app/store';
import {
  Skeleton,
  Empty,
  Collapse,
  Typography,
  Upload,
  Button,
  message,
  Menu,
  Dropdown,
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
} from '@ant-design/icons';

import { FormattedMessage, useIntl } from 'react-intl';
import withTranslations from 'app/components/HOGs/withTranslations';

import * as way from 'app/libs/core/PubSubWays';
import { publish } from 'app/libs/core/PubSub';

import { DownloadTourGpsProps } from '../../../constants/PropType/propTypesDownloadTourGps';
import { fullDataProps } from '../../../constants/PropType/propTypesFullData';
import { MapDataProps } from '../../../constants/PropType/propTypesMapData';
// API
import tourPrevAPI from '../../../API/tour.prev.api';
// CSS
import './fullTourViewMobile.css';

// ANTD

// Slider
import 'react-image-gallery/styles/css/image-gallery.css';

// MAP

import MultyBuilder from '../../Desctop/TourFullView/CreateTour/MultyBuilder';

// Component
import TourTypeFullView from '../../Desctop/TourFullView/components/tourTypeFullView';
import showDeleteConfirm from '../../Desctop/TourFullView/tourFull';
import MultiDayTabs from '../../Desctop/TourFullView/components/multiDayTabs';
import PointsTourFull from '../../Desctop/TourFullView/Points/Points';
import AutoSaveTour from '../../Desctop/TourFullView/CreateTour/autoSaveTour';

import { dataList as dataListGpxBrand } from '../../Desctop/downloadGps/components/moreOptionView';
import TimeAndDistanceFullView from '../../Desctop/TourFullView/components/TimeAndDistanceFullView';
import { ListMultiTourParts } from '../../Desctop/TourFullView/Parts/ListMultiTourParts';
// Utility
import { getDescription } from '../../Utility/utility';

// UTILITY
import { ErrorBoundary } from '../../Utility/errorBoundary';
import { AccessTypeWrapper } from '../../Desctop/TourFullView/CreateTour/AccesibilityType/AccessTypeWrapper';
import { isTourPublic } from '../../../constants/tourAccessibilityTypes.constants';

import {
  PublicTourIcon,
  PrivateTourIcon,
} from '../../Desctop/TourFullView/components/svg';
import ToolbarLayout from '../../Desctop/TourFullView/components/toolbars';
import TextEditor from '../../Desctop/TourFullView/components/textEditor';

const { Panel } = Collapse;
const { Item } = Popover;

const updatePointMedia = (pointId, images) => {
  publish(way.DRIVE_PREVIEW_POINT_UPDATE, { id: pointId, images });
};

const onMouseOverHandler = (e) => {
  e.preventDefault();
  document.getElementById('tourFullMobileLayout').style.pointerEvents = 'none';
};

const onMouseOverHandler2 = (e) => {
  e.preventDefault();
  document.getElementById('tourFullMobileLayout').style.pointerEvents = 'all';
};

const onMouseOverHandler3 = (e) => {
  e.preventDefault();
  document.getElementById('tourFullMobileLayout').style.pointerEvents = 'all';
};

const hasUserPermition = (props) =>
  props.currentUserId &&
  props.tourData.user &&
  props.currentUserId === props.tourData.user.id;

const addNewPointPicture = (file, props) => {
  props.tourData.points.forEach((item) => {
    if (item.id === props.fullData.dataPoint.id) {
      item.images.unshift(file);
      updatePointMedia(props.fullData.dataPoint.id, item.images);
    }
  });
};

// const deletePointPictures = (file, props) => {
//   props.tourData.points.forEach((item) => {
//     if (item.id === props.fullData.dataPoint.id) {
//       item.images.splice(item.images.indexOf(file), 1);
//       updatePointMedia(props.fullData.dataPoint.id, item.images);
//     }
//   });
// };

const addNewImages = (data, props, imgMain, type, tr) => {
  return (
    <Upload
      name="file"
      listType="picture-card"
      multiple
      defaultFileList={imgMain}
      showUploadList={{
        showPreviewIcon: false,
        showDownloadIcon: false,
        showRemoveIcon: true,
      }}
      action={tourPrevAPI.getUploadPictureURL()}
      onChange={(info) => {
        const { status } = info.file;
        if (status === 'done') {
          if (type === 'main') {
            props.uploadImage(info);
          } else {
            addNewPointPicture(info.file, props);
          }
          message.success(
            `${info.file.name} ${tr['file uploaded successfully']}`
          );
        } else if (status === 'error') {
          message.error(`${info.file.name} ${tr['file upload failed']}`);
        }
      }}
    >
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">
          <FormattedMessage id="Add image" defaultMessage="Add image" />
        </div>
      </div>
    </Upload>
  );
};

const sliderMainInfo = (data) => {
  if (data.images && data.images.length > 0) {
    return (
      <WingBlank>
        <WhiteSpace />
        <Carousel
          className="space-carousel"
          frameOverflow="visible"
          cellSpacing={10}
          slideWidth={0.8}
          dots={false}
        >
          {data.images.map((val) => {
            return (
              <img
                src={val.fullpath ? val.fullpath : val.thumbUrl}
                alt={`${val.fullpath}`}
                key={`${val.fullpath}`}
                style={{
                  width: '100%',
                  verticalAlign: 'top',
                  objectFit: 'cover',
                  height: 150,
                }}
                onLoad={() => {
                  // fire window resize event to change height
                  window.dispatchEvent(new Event('resize'));
                }}
              />
            );
          })}
        </Carousel>
        <WhiteSpace />
      </WingBlank>
    );
  }
  return (
    <div className="sliderBottomEmpty">
      <Empty description="No Image" />
    </div>
  );
};

const mainInfo = (props, imgMain, tr, fullData) => {
  const { data, fetching } = fullData;
  const getContent = () => {
    if (fetching) {
      return (
        <div
          style={{
            height: 80,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator />
        </div>
      );
    }
    if (props.edit) {
      return addNewImages(data, props, imgMain, 'main', tr);
    }
    return sliderMainInfo(data);
  };

  return (
    <div className="mainInfoMobile">
      {getContent()}
      <TextEditor {...props} />
    </div>
  );
};

const Accord = (props, imgMain, setImageMain, fullData) => {
  const customPanelStyle = {
    background: '#fff',
    borderRadius: 4,
    marginBottom: 10,
    border: '1px solid ligthgray',
    overflow: 'hidden',
    boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
  };
  return (
    <>
      <Collapse
        accordion
        expandIconPosition="right"
        defaultActiveKey={['1']}
        bordered={false}
        style={{ backgroundColor: '#f5f5f5' }}
      >
        <Panel header="Main Info" key="1" style={customPanelStyle}>
          {mainInfo(props, imgMain, props.tr, fullData)}
        </Panel>
        <WhiteSpace
          style={{ backgroundColor: '#f5f5f5', pointerEvents: 'all' }}
          onTouchStart={(e) => onMouseOverHandler2(e)}
        />
        <Panel header="Options" key="2" style={customPanelStyle}>
          <ErrorBoundary>
            <ToolbarLayout
              hasUserPermition={hasUserPermition}
              currentTourId={props.currentTourId}
              closePreview={props.closePreview}
              fullScreenMode={props.fullScreenMode}
            />
          </ErrorBoundary>
        </Panel>
      </Collapse>
    </>
  );
};

const titlePopover = (props) => {
  const [visible, setVisible] = React.useState(false);

  const popoverContent = [
    hasUserPermition({ ...props, tourData: props.fullData.data }) &&
    !props.edit ? (
      <Item
        key="4"
        value="edit"
        icon={<EditOutlined className="editImg" style={{ fontSize: 16 }} />}
      >
        Edit
      </Item>
    ) : null,
    hasUserPermition({ ...props, tourData: props.fullData.data }) ? (
      <Item
        key="5"
        value="delete"
        icon={<DeleteOutlined className="deleteImg" style={{ fontSize: 16 }} />}
      >
        Delete
      </Item>
    ) : null,
  ];

  const onSelect = (value) => {
    let url = props.router ? props.router.location.pathname.split('/') : [];
    url = url.splice(-1, 1);
    switch (value) {
      case 'edit':
        props.editChoose();
        break;

      case 'delete':
        props.deleteTourDay(props.fullData, url);
        break;

      case 'bookmark':
        props.chooseBookmark();
        break;
      default:
        break;
    }
    setVisible(!visible);
  };

  return hasUserPermition({ ...props, tourData: props.fullData.data }) ? (
    <Popover
      overlayClassName="fortest"
      overlayStyle={{ color: 'currentColor', width: '150px' }}
      visible={visible}
      placement="bottomRight"
      overlay={popoverContent}
      align={{
        overflow: { adjustY: 0, adjustX: 0 },
        offset: [-17, 5],
      }}
      onVisibleChange={() => setVisible(!visible)}
      onSelect={(e) => onSelect(e.props.value)}
    >
      <div
        style={{
          height: '100%',
          padding: '0 15px',
          marginRight: '-15px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <MoreOutlined style={{ fontSize: 25 }} />
      </div>
    </Popover>
  ) : (
    <div onClick={() => props.chooseBookmark()} aria-hidden>
      {props.bookmark}
    </div>
  );
};

const downloadGpxPopover = (props, fullData, isLoggedIn) => {
  const { title, id } = fullData.data;
  const styleItem = {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
  };
  const downloadGpx = (option) => {
    const { name, scope, type, extension, reverse, tourAs } = option;
    if (!isLoggedIn) {
      store.dispatch(loginModalOpen(true));
      return;
    }
    tourPrevAPI.downloadGpx(
      title,
      id,
      name,
      scope,
      type,
      extension,
      reverse,
      tourAs
    );
  };
  const menu = (
    <Menu>
      {dataListGpxBrand.map((item) => {
        return (
          <Menu.Item
            key={`${item.option.name}`}
            style={styleItem}
            onClick={() => downloadGpx(item.option)}
          >
            <img
              src={item.img}
              style={{ marginRight: 10, marginBottom: 3 }}
              alt="gpx"
            />
            <span>{item.option.name}</span>
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      onTouchStart={(e) => onMouseOverHandler3(e)}
      getPopupContainer={(trigger) => trigger.parentNode}
      placement="bottomLeft"
      overlayStyle={{ width: 170 }}
    >
      <Button className="gps" type="primary" style={{ width: 145 }}>
        <FormattedMessage id="Download" defaultMessage="Download" />
      </Button>
    </Dropdown>
  );
};

const Title = (props) => {
  const { fullData } = props;
  return (
    <div className="titleMain">
      <div className="title">
        {fullData.fetching === true ? (
          <Skeleton paragraph={false} title={{ width: 200 }} active />
        ) : (
          <Typography.Paragraph
            editable={
              props.edit
                ? {
                    editing: true,
                    onChange: (str) => {
                      if (str !== fullData.activeMultiPart.title)
                        props.onChangeTitle(str);
                    },
                  }
                : false
            }
            ellipsis
            onDoubleClick={() => props.editChoose(!props.edit)}
          >
            {fullData.activeMultiPart.title}
          </Typography.Paragraph>
        )}
      </div>
      {titlePopover(props)}
    </div>
  );
};

const View = (props) => {
  return (
    <div className="view">
      <div className="viewText">
        <TimeAndDistanceFullView />
      </div>
      <div className="edit">
        <div className="tourTypeIcon">
          <TourTypeFullView
            data={props.fullData}
            isEdit={props.edit}
            isCreate={props.ride}
            setArrowTourType={props.setArrowTourType}
          />
        </div>
      </div>
    </div>
  );
};

const PointData = (props, fullData) => {
  const sliderPoint = sliderMainInfo(fullData.dataPoint);

  const savePointData = (title, desc) => {
    props.tourData.points.forEach((item) => {
      if (item.id === props.fullData.dataPoint.id) {
        item.title = title;
        item.description = desc;
      }
    });
    publish(way.DRIVE_PREVIEW_POINT_UPDATE, {
      id: props.fullData.dataPoint.id,
      title,
      desc,
    });
  };

  const changeDesc = (val) => {
    if (val !== getDescription(props.fullData.dataPoint)) {
      savePointData(props.fullData.dataPoint.title, val);
    } else if (val === getDescription(props.fullData.dataPoint)) {
      savePointData(props.fullData.dataPoint.title, '');
    }
  };

  return (
    <div className="pointInfo">
      <div className="title">{props.fullData.dataPoint.address}</div>
      {props.edit ? addNewImages(props.fullData.dataPoint, props) : sliderPoint}
      <div className="desc">
        <Typography.Paragraph
          editable={
            props.edit
              ? {
                  editing: true,
                  onChange: (str) => {
                    if (str !== props.fullData.dataPoint.description)
                      changeDesc(str);
                  },
                }
              : false
          }
          ellipsis={false}
          onDoubleClick={() => props.editChoose(!props.edit)}
        >
          {getDescription(props.fullData.dataPoint)}
        </Typography.Paragraph>
      </div>
    </div>
  );
};

const TourFullViewMobile = (props) => {
  const [imgMain, setImageMain] = useState([]);
  const fullData = useSelector((store) => store.tourFullData);
  const data = useSelector((store) => store.tourFullData.data);
  const isLoggedIn = useSelector((store) => store.authentication.isLoggedIn);

  useEffect(() => {
    if (fullData.activeMultiPart.images) {
      const { images } = fullData.activeMultiPart;
      const data = images.map((img) => {
        return { ...img, uid: img.id, url: img.fullpath };
      });
      setImageMain(data);
    }
  }, [fullData.activeMultiPart]);
  const intl = useIntl();
  const accessibilityPanelText = {
    'For me only': intl.formatMessage({
      id: 'For me only',
      defaultMessage: 'For me only',
    }),
    'My friends and me': intl.formatMessage({
      id: 'My friends and me',
      defaultMessage: 'My friends and me',
    }),
    'Select friends': intl.formatMessage({
      id: 'Select friends',
      defaultMessage: 'Select friends',
    }),
    'Add some friends so you can share the tour with them': intl.formatMessage({
      id: 'Add some friends so you can share the tour with them',
      defaultMessage: 'Add some friends so you can share the tour with them',
    }),
    'All Tourstart users': intl.formatMessage({
      id: 'All Tourstart users',
      defaultMessage: 'All Tourstart users',
    }),
    'My Bike Club': intl.formatMessage({
      id: 'My Bike Club',
      defaultMessage: 'My Bike Club',
    }),
    'No BikeClub': intl.formatMessage({
      id: 'No BikeClub',
      defaultMessage: 'No BikeClub',
    }),
    'My BikerBed': intl.formatMessage({
      id: 'My BikerBed',
      defaultMessage: 'My BikerBed',
    }),
    'No BikerBed': intl.formatMessage({
      id: 'No BikerBed',
      defaultMessage: 'No BikerBed',
    }),
    Private: intl.formatMessage({ id: 'Private', defaultMessage: 'Private' }),
    Public: intl.formatMessage({ id: 'Public', defaultMessage: 'Public' }),
    'Import GPS file': intl.formatMessage({
      id: 'Import GPS file',
      defaultMessage: 'Import GPS file',
    }),
  };

  const url = props.router
    ? props.router.location.pathname.split('/').splice(-1, 1)
    : [];

  const deleteDay = () => {
    return showDeleteConfirm(
      fullData,
      props.deleteTourDay,
      props.title,
      intl,
      url,
      fullData.activeTourTab
    );
  };

  const getComp = () => {
    if (fullData.fetching === true) {
      return (
        <div
          style={{
            height: 50,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator />
        </div>
      );
    }
    if (fullData.activeTourTab === '0' && fullData.data.multiDay === true) {
      return <ListMultiTourParts {...props} />;
    }

    return (
      <div
        onTouchStart={(e) => onMouseOverHandler2(e)}
        style={{ pointerEvents: 'all', backgroundColor: '#f5f5f5', flex: 1 }}
        className={props.edit ? 'editTourMobile' : ''}
      >
        <PointsTourFull {...props} />
        {Object.keys(fullData.dataPoint).length !== 0 ? (
          PointData(props, fullData)
        ) : (
          <div style={{ height: 10 }} />
        )}
      </div>
    );
  };

  const getElem = () => {
    if (hasUserPermition({ ...props, tourData: data })) {
      return (
        <AccessTypeWrapper
          {...props}
          accessibilityPanelText={accessibilityPanelText}
          mobile
        />
      );
    }
    if (isTourPublic(fullData.data.tourType)) {
      return <PublicTourIcon />;
    }
    return <PrivateTourIcon />;
  };

  return (
    <div
      id="tourFullMobileLayout"
      className={
        props.edit ? 'tourFullMobileLayout' : 'tourFullMobileLayout view'
      }
      style={{ height: window.innerHeight - 45 }}
    >
      <WhiteSpace />
      <div className="main_title" onTouchStart={(e) => onMouseOverHandler2(e)}>
        <Title {...props} fullData={fullData} />
        {!props.edit && fullData.data.user ? (
          <span
            className="createBy"
            style={{
              position: 'absolute',
              top: 40,
              color: 'rgba(0, 0, 0, 0.6)',
            }}
          >
            by
            <Link
              to={`/member/profile/${fullData.data.user.name}_${fullData.data.user.id}`}
              style={{
                marginLeft: 5,
                color: 'rgba(0, 0, 0, 0.6)',
                textDecoration: 'underline',
              }}
            >
              {fullData.data.user.name}
            </Link>
          </span>
        ) : null}
        <div
          className="tourPermissionType"
          style={{ right: 18, top: 48, left: 'auto', position: 'absolute' }}
        >
          {getElem()}
        </div>
        <View {...props} fullData={fullData} />
      </div>
      <WhiteSpace
        style={{ backgroundColor: '#f5f5f5', pointerEvents: 'all' }}
        onTouchStart={(e) => onMouseOverHandler2(e)}
      />
      {fullData.data.multiDay || props.edit ? (
        <div onTouchStart={(e) => onMouseOverHandler2(e)}>
          <MultiDayTabs {...props} deleteDay={deleteDay} intl={intl} />
        </div>
      ) : null}
      <WhiteSpace
        style={{ backgroundColor: '#f5f5f5', pointerEvents: 'all' }}
        onTouchStart={(e) => onMouseOverHandler2(e)}
      />
      <div
        className="Map"
        style={{ position: 'relative', height: 100 }}
        onTouchStart={(e) => onMouseOverHandler(e)}
      />
      <div
        className="tourFullViewButton"
        onTouchStart={(e) => onMouseOverHandler2(e)}
        style={{ pointerEvents: 'all' }}
      >
        <MultyBuilder
          multiData={props.prevPoly}
          isEditable={props.edit}
          isExistId={!!props.currentTourId}
          toogleEdit={props.editChoose}
          changeCursorWrapperClassName={props.changeCursorWrapperClassName}
          clearTour={props.clearTour}
          isClearTour={props.isClearTour}
        />
        <AutoSaveTour
          isRidePlan={props.currentTourId === 0}
          setPageBlock={props.setPageBlock}
          isWrongRoutesExists={props.isWrongRoutesExists}
          isThereAnyWrongRouteInAllTourPages={
            props.isThereAnyWrongRouteInAllTourPages
          }
          fullScreenMode={props.fullScreenMode}
          isShapingDataExists={props.isShapingDataExists}
          hasUserPermition={props.hasUserPermition}
          currentTourId={props.currentTourId}
          closePreview={props.closePreview}
          clearTour={props.clearTour}
        />
        {!props.edit && (
          <>
            <Link to={`/createtour?copy=${props.ride}`}>
              <Button className="ridePlan">
                <FormattedMessage
                  id="Plan in Create Tour"
                  defaultMessage="Plan in Create Tour"
                />
              </Button>
            </Link>
            {downloadGpxPopover(props, fullData, isLoggedIn)}
          </>
        )}
      </div>
      <div
        onTouchStart={(e) => onMouseOverHandler2(e)}
        style={{ pointerEvents: 'all', backgroundColor: '#f5f5f5' }}
      >
        {Accord(props, imgMain, setImageMain, fullData)}
      </div>
      {getComp()}
    </div>
  );
};

TourFullViewMobile.displayName = 'TourFullViewMobile';
TourFullViewMobile.propTypes = {
  fullData: PropTypes.shape(fullDataProps),
  tourPointDataAction: PropTypes.func,
  viewString: PropTypes.string,
  measureString: PropTypes.string,
  desc: PropTypes.string,
  title: PropTypes.string,
  preview: PropTypes.object,
  tourType: PropTypes.func,
  bookmark: PropTypes.object,
  chooseBookmark: PropTypes.func,
  TourDownloadBasketData: PropTypes.func,
  TourDownloadCoord: PropTypes.func,
  downloadTourGps: PropTypes.shape(DownloadTourGpsProps),
  mapData: PropTypes.shape(MapDataProps),
  openModalTourDownload: PropTypes.func,
  ride: PropTypes.any,
  edit: PropTypes.bool,
  editChoose: PropTypes.func,
};

export default withTranslations(TourFullViewMobile);
